// external imports
import React from 'react'
// local imports
import { primaryColor } from '~/colors'

const Indicator = ({ active }) => (
    <div style={styles.container}>
        <div style={{ ...styles.base, ...(active ? styles.active : styles.inactive) }} />
    </div>
)

const styles = {
    container: {
        width: 6,
        marginRight: 5
    },
    base: {
        width: 0,
        height: 0
    },
    inactive: {
        borderTop: '4px solid transparent',
        borderBottom: '4px solid transparent',
        borderLeft: `5px solid ${primaryColor}`
    },
    active: {
        borderLeft: '4px solid transparent',
        borderRight: '4px solid transparent',
        borderTop: `5px solid ${primaryColor}`
    }
}

export default Indicator



// WEBPACK FOOTER //
// ./src/components/Accordion/Indicator.js